import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import img1 from "../assets/images/for-him/image-1.png";
import img2 from "../assets/images/for-him/image-2.png";
import img3 from "../assets/images/for-him/image-3.png";
import img4 from "../assets/images/for-him/image-4.png";
import img5 from "../assets/images/for-him/image-5.png";
import img6 from "../assets/images/for-him/image-6.png";
import img7 from "../assets/images/for-him/image-7.png";
import img8 from "../assets/images/for-him/image-8.png";
import img9 from "../assets/images/for-him/image-9.png";
import "../assets/css/collection-page.css";

const PRODUCTS = [
  { src: img1, title: "Signature Noir",     type: "Eau de Parfum · 100 ml" },
  { src: img2, title: "Classic Elegance",   type: "Eau de Toilette · 75 ml" },
  { src: img3, title: "Midnight Musk",      type: "Parfum Extrait · 50 ml"  },
  { src: img4, title: "Ocean Breeze",       type: "Eau de Parfum · 100 ml" },
  { src: img5, title: "Woodland Charm",     type: "Eau de Toilette · 100 ml"},
  { src: img6, title: "Dark Amber",         type: "Parfum Extrait · 75 ml"  },
  { src: img7, title: "Oud Intense",        type: "Eau de Parfum · 50 ml"  },
  { src: img8, title: "Cedar & Vetiver",    type: "Eau de Toilette · 100 ml"},
  { src: img9, title: "Royal Musk",         type: "Parfum Extrait · 100 ml" },
];

const ForHim = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      {/* ── HERO BANNER ── */}
      <section className="cp-hero cp-hero--him">
        {/* Left — image panel */}
        <div className="cp-hero-img-panel">
          <img src={img1} alt="For Him" className="cp-hero-img" />
          <div className="cp-hero-img-overlay" />

          {/* floating accent card */}
          <div className="cp-hero-badge">
            <span className="cp-hero-badge-num">9</span>
            <span className="cp-hero-badge-label">Exclusive<br />Fragrances</span>
          </div>
        </div>

        {/* Right — text panel */}
        <div className="cp-hero-text-panel">
          <div className="cp-hero-text-inner">
            <span className="cp-hero-eyebrow">Pour Lui · Perfume Paris</span>

            <h1 className="cp-hero-title">
              Crafted<br />
              <em>For the<br />Modern Man</em>
            </h1>

            <div className="cp-hero-divider" />

            <p className="cp-hero-desc">
              Bold woods, smoky ouds, crisp aquatics — every fragrance
              in our men's collection is a declaration of character.
              Wear the scent that tells your story.
            </p>

            <ul className="cp-hero-tags">
              <li>Woody &amp; Spicy</li>
              <li>Aquatic &amp; Fresh</li>
              <li>Oriental &amp; Oud</li>
            </ul>

            <div className="cp-hero-actions">
              <a href="#collection" className="cp-btn-primary">Explore Collection</a>
              <Link to="/shop" className="cp-btn-ghost">View All</Link>
            </div>
          </div>
        </div>
      </section>

      {/* ── COLLECTION GRID ── */}
      <section id="collection" className="cp-grid-section">
        <div className="container">
          <div className="cp-grid-header">
            <span className="cp-grid-tag">Men's Collection</span>
            <h2 className="cp-grid-title">Exclusive <em>Fragrances</em></h2>
            <div className="cp-grid-line" />
            <p className="cp-grid-sub">
              Discover our signature fragrances crafted for him — a perfect blend of
              sophistication, elegance, and bold masculinity in every drop.
            </p>
          </div>

          <div className="row g-4 justify-content-center">
            {PRODUCTS.map((p, i) => (
              <div key={i} className="col-12 col-sm-6 col-lg-4">
                <div className="cp-card">
                  <div className="cp-card-img-wrap">
                    <img src={p.src} alt={p.title} className="cp-card-img" />
                    <div className="cp-card-overlay">
                      <Link to="/shop" className="cp-card-cta">View Details</Link>
                    </div>
                  </div>
                  <div className="cp-card-body">
                    <h3 className="cp-card-name">{p.title}</h3>
                    <p className="cp-card-type">{p.type}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default ForHim;
